var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObjetivo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "objetivo",
    d: "M13.795,5.467a6.766,6.766,0,1,0,4.739,4.739.75.75,0,1,1,1.447-.4A8.266,8.266,0,1,1,14.191,4.02a.75.75,0,1,1-.4,1.447Zm8.782,2.616a.75.75,0,0,0-.506.932A10.489,10.489,0,1,1,14.985,1.93.75.75,0,1,0,15.411.492a11.989,11.989,0,1,0,8.1,8.1.75.75,0,0,0-.932-.506ZM12,9a3.049,3.049,0,0,1,.331.018.75.75,0,1,0,.164-1.491A4.5,4.5,0,1,0,16.5,12,.75.75,0,1,0,15,12a3,3,0,1,1-3-3ZM15.83,7.11,16.2,3.362a.75.75,0,0,1,.216-.456L19.106.219a.75.75,0,0,1,1.278.472L20.6,3.4l2.712.213a.75.75,0,0,1,.472,1.278L21.094,7.581a.75.75,0,0,1-.456.216L16.89,8.17l-4.36,4.36a.75.75,0,0,1-1.061-1.061Zm1.557-.5,2.836-.283,1.347-1.347-1.728-.136a.75.75,0,0,1-.689-.689L19.016,2.43,17.669,3.777Z",
    transform: "translate(0 0.001)",
    fill: "#737373"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjetivo);
export default __webpack_public_path__ + "static/media/objetivo.c85a3dbb557c794212e2f3daf9fb0ba5.svg";
export { ForwardRef as ReactComponent };